import React from 'react';
import {BrowserRouter as Router} from "react-router-dom";
import {Security} from '@okta/okta-react';
import {Main} from "./components/Main";
import config from "./shared/config";
import AEHeader from "./components/Header";
import AEFooter from "./components/Footer";
import {OktaAuth} from "@okta/okta-auth-js";

const oktaAuth = new OktaAuth(config);
class App extends React.Component {
    render() {
        return (
            <Router>
                <Security oktaAuth={oktaAuth}>
                    <div className="uxf-sticky-footer">
                        <div className="uxf-main-content">
                            <AEHeader/>
                            <Main/>
                        </div>
                        <AEFooter/>
                    </div>
                </Security>
            </Router>
        );
    }
}

export default App;
